import React, { ReactNode } from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 6px;
  color: var(--text-secondary);
`;

const Title = styled.span`
  text-align: center;
  font-family: var(--font-bold);
  font-size: 18px;
`;

const Description = styled.span`
  text-align: center;
  font-size: 14px;
`;

type Props = {
  title: ReactNode;
  description: ReactNode;
};

const UserManagementEmptyState = ({ title, description }: Props) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

export default UserManagementEmptyState;
